import React, { useState } from 'react';
// Public endpoint — same-origin fetch, no lib/api edit required.

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@500;600;700&family=Playfair+Display:ital,wght@0,500;0,600;1,500&display=swap');

.fin-wrap{--navy:#070b16;--panel:#0a1124;--gold:#c9a84c;--gold-lt:#e7ca72;--gold-dk:#8f6f2c;--teal:#37d0c4;--ink:#06090f;--text:#e9edf5;--muted:#9aa6bc;--line:rgba(201,168,76,.30);
  min-height:100vh;width:100%;box-sizing:border-box;
  background:
    radial-gradient(1100px 520px at 50% -8%, #16203c 0%, rgba(22,32,60,0) 60%),
    radial-gradient(820px 620px at 100% 120%, rgba(55,208,196,.10) 0%, rgba(55,208,196,0) 55%),
    linear-gradient(180deg,#070b16,#05070f);
  display:flex;align-items:flex-start;justify-content:center;padding:30px 16px 60px;
  font-family:'Playfair Display',Georgia,serif;color:var(--text);-webkit-font-smoothing:antialiased;}
.fin-frame{position:relative;width:100%;max-width:600px;background:linear-gradient(180deg,var(--panel),#070c1a);
  border:1px solid var(--line);border-radius:14px;padding:56px 42px 40px;
  box-shadow:0 40px 120px rgba(0,0,0,.6), inset 0 0 0 4px rgba(201,168,76,.05);}
.fin-frame::before{content:'';position:absolute;inset:9px;border:1px solid rgba(201,168,76,.16);border-radius:9px;pointer-events:none;}
.fin-corner{position:absolute;width:84px;height:84px;}
.fin-corner-tl{top:5px;left:5px;}
.fin-corner-tr{top:5px;right:5px;transform:scaleX(-1);}
.fin-corner-bl{bottom:5px;left:5px;transform:scaleY(-1);}
.fin-corner-br{bottom:5px;right:5px;transform:scale(-1,-1);}
.fin-center{text-align:center;position:relative;z-index:1;}
.fin-logo{display:block;margin:0 auto 8px;width:188px;max-width:62%;height:auto;filter:drop-shadow(0 10px 26px rgba(0,0,0,.5));}
.fin-kicker{font-family:'Cinzel',serif;color:var(--teal);font-size:12px;letter-spacing:5px;font-weight:600;text-transform:uppercase;}
.fin-wordmark{font-family:'Cinzel',serif;font-weight:700;font-size:21px;letter-spacing:3px;margin:9px 0 0;text-transform:uppercase;
  background:linear-gradient(180deg,var(--gold-lt),var(--gold) 55%,var(--gold-dk));-webkit-background-clip:text;background-clip:text;color:transparent;}
.fin-divider{display:flex;align-items:center;justify-content:center;gap:14px;margin:18px auto;max-width:300px;}
.fin-divider i{height:1px;flex:1;background:linear-gradient(90deg,transparent,var(--line));}
.fin-divider i.r{background:linear-gradient(270deg,transparent,var(--line));}
.fin-diamond{width:7px;height:7px;transform:rotate(45deg);background:var(--gold);box-shadow:0 0 0 3px rgba(201,168,76,.10);}
.fin-headline{font-family:'Playfair Display',serif;font-weight:600;font-size:38px;line-height:1.08;margin:4px 0 12px;
  background:linear-gradient(180deg,var(--gold-lt),var(--gold) 60%,var(--gold-dk));-webkit-background-clip:text;background-clip:text;color:transparent;}
.fin-lead{color:var(--muted);font-size:15px;line-height:1.65;max-width:440px;margin:0 auto;}
.fin-event-date{font-family:'Playfair Display',serif;font-size:21px;color:var(--gold-lt);letter-spacing:.4px;}
.fin-event-venue{color:#d7dce6;font-size:15px;line-height:1.5;margin-top:6px;}

.fin-form{margin-top:4px;text-align:left;}
.fin-field{display:block;margin-bottom:17px;}
.fin-label{display:block;font-family:'Cinzel',serif;font-size:11px;letter-spacing:1.5px;text-transform:uppercase;color:#b9c2d4;margin-bottom:7px;}
.fin-input{width:100%;box-sizing:border-box;background:rgba(255,255,255,.03);border:1px solid var(--line);border-radius:10px;
  padding:13px 15px;font-size:15px;color:var(--text);font-family:'Playfair Display',Georgia,serif;transition:.15s;}
.fin-input::placeholder{color:rgba(154,166,188,.55);}
.fin-input:focus{outline:none;border-color:var(--gold);box-shadow:0 0 0 3px rgba(201,168,76,.14);background:rgba(255,255,255,.05);}
.fin-two{display:grid;grid-template-columns:1fr 1fr;gap:12px;}
.fin-seg-row{display:flex;gap:10px;}
.fin-seg{flex:1;background:rgba(255,255,255,.02);border:1px solid var(--line);border-radius:10px;padding:13px 8px;
  font-family:'Cinzel',serif;font-size:13px;letter-spacing:.4px;color:var(--text);cursor:pointer;transition:.15s;}
.fin-seg:hover{border-color:rgba(201,168,76,.6);}
.fin-seg.active{background:linear-gradient(180deg,var(--gold-lt),var(--gold));color:var(--ink);border-color:var(--gold);box-shadow:0 8px 22px rgba(201,168,76,.22);font-weight:600;}
.fin-note{background:rgba(55,208,196,.07);border:1px solid rgba(55,208,196,.25);color:#9fe8e0;border-radius:10px;padding:11px 14px;font-size:13.5px;margin-bottom:17px;}
.fin-error{background:rgba(220,80,80,.10);border:1px solid rgba(220,80,80,.4);color:#f0b4b4;border-radius:10px;padding:11px 14px;font-size:13.5px;margin-bottom:14px;}
.fin-submit{width:100%;margin-top:6px;padding:15px;border:none;border-radius:11px;cursor:pointer;
  font-family:'Cinzel',serif;font-size:15px;letter-spacing:1.5px;text-transform:uppercase;color:var(--ink);font-weight:600;
  background:linear-gradient(180deg,var(--gold-lt),var(--gold) 70%,var(--gold-dk));box-shadow:0 12px 30px rgba(201,168,76,.28);transition:.15s;}
.fin-submit:hover{filter:brightness(1.05);}
.fin-submit:disabled{opacity:.65;cursor:default;}
.fin-fine{text-align:center;color:var(--muted);font-size:12px;margin-top:13px;}
.fin-footer{margin-top:22px;text-align:center;font-family:'Cinzel',serif;color:var(--teal);font-size:11px;letter-spacing:2.5px;text-transform:uppercase;}

.fin-tick{width:62px;height:62px;border-radius:50%;margin:4px auto 12px;display:flex;align-items:center;justify-content:center;
  border:2px solid var(--gold);color:var(--gold-lt);font-size:30px;background:rgba(201,168,76,.08);}
.fin-success-title{font-family:'Playfair Display',serif;font-weight:600;font-size:28px;margin:6px 0;
  background:linear-gradient(180deg,var(--gold-lt),var(--gold-dk));-webkit-background-clip:text;background-clip:text;color:transparent;}
.fin-success-text{color:#cfd6e4;font-size:15px;line-height:1.65;max-width:430px;margin:8px auto;}
.fin-ref-box{border:1px solid var(--line);border-radius:12px;padding:16px;margin:18px auto;max-width:260px;background:rgba(255,255,255,.02);}
.fin-ref-label{font-family:'Cinzel',serif;color:var(--teal);font-size:11px;letter-spacing:3px;text-transform:uppercase;}
.fin-ref-code{font-family:'Cinzel',serif;color:var(--gold-lt);font-size:23px;font-weight:700;letter-spacing:3px;margin-top:7px;}

@media(max-width:480px){.fin-frame{padding:46px 22px 30px}.fin-headline{font-size:31px}.fin-two{grid-template-columns:1fr}}
`;

const Defs = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
    <defs>
      <linearGradient id="finGold" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#e7ca72" /><stop offset=".55" stopColor="#c9a84c" /><stop offset="1" stopColor="#8f6f2c" />
      </linearGradient>
      <linearGradient id="finTeal" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#5fe6da" /><stop offset="1" stopColor="#2bb8ad" />
      </linearGradient>
    </defs>
  </svg>
);

const Corner = ({ pos }) => (
  <svg className={'fin-corner fin-corner-' + pos} width="84" height="84" viewBox="0 0 120 120" aria-hidden="true">
    <g fill="none" stroke="url(#finGold)" strokeWidth="1.5" strokeLinecap="round">
      <path d="M18 60 L18 18 L60 18" />
      <path d="M26 52 L26 26 L52 26" />
      <path d="M26 26 C 44 28, 52 36, 52 52" />
      <path d="M18 18 C 32 10, 46 10, 58 14" />
      <path d="M18 18 C 10 32, 10 46, 14 58" />
      <path d="M52 52 C 60 44, 66 42, 76 42" />
      <path d="M52 52 C 44 60, 42 66, 42 76" />
    </g>
    <circle cx="52" cy="52" r="2.4" fill="url(#finGold)" />
    <circle cx="76" cy="42" r="1.7" fill="url(#finTeal)" />
    <circle cx="42" cy="76" r="1.7" fill="url(#finTeal)" />
  </svg>
);

const Divider = () => (
  <div className="fin-divider"><i /><span className="fin-diamond" /><i className="r" /></div>
);

export default function FinaleRegistrationPage() {
  const [form, setForm] = useState({
    full_name: '', email: '', phone: '',
    registrant_type: '', attendance_mode: '',
    graduation_year: '', department: '',
  });
  const [status, setStatus] = useState('idle');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const chooseType = (t) =>
    setForm((f) => ({ ...f, registrant_type: t, attendance_mode: t === 'student' ? 'in_person' : (f.attendance_mode || '') }));
  const isAlumni = form.registrant_type === 'alumni';

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.full_name.trim()) return setError('Please enter your full name.');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return setError('Please enter a valid email address.');
    if (!form.registrant_type) return setError('Please select whether you are a student or an alumnus.');
    if (isAlumni && !form.attendance_mode) return setError('Please choose in-person or online attendance.');

    setStatus('loading');
    try {
      const res = await fetch('/api/public/finale-register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Something went wrong. Please try again.');
      setResult(data);
      setStatus('done');
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
      setStatus('error');
    }
  };

  return (
    <div className="fin-wrap">
      <style dangerouslySetInnerHTML={{ __html: CSS }} />
      <Defs />
      <div className="fin-frame">
        <Corner pos="tl" /><Corner pos="tr" /><Corner pos="bl" /><Corner pos="br" />
        <div className="fin-center">
          <img className="fin-logo" src="/futurum-logo.png" alt="Futurum Innovation Awards" />
          <div className="fin-kicker">Season II · Grand Finale</div>
          <Divider />

          {status === 'done' ? (
            <Success result={result} email={form.email} />
          ) : (
            <>
              <h1 className="fin-headline">Reserve Your Seat</h1>
              <p className="fin-lead">
                An evening honouring the finest final-year engineering innovation at Obafemi Awolowo
                University. Attendance is free, but registration is required.
              </p>
              <Divider />
              <div>
                <div className="fin-event-date">Thursday, 30 July 2026 · 3:00 PM</div>
                <div className="fin-event-venue">African Centre of Excellence<br />Obafemi Awolowo University, Ile-Ife</div>
              </div>
              <Divider />

              <form className="fin-form" onSubmit={submit}>
                <label className="fin-field">
                  <span className="fin-label">Full name</span>
                  <input className="fin-input" value={form.full_name} onChange={set('full_name')} placeholder="e.g. Adaeze Okonkwo" autoComplete="name" />
                </label>
                <label className="fin-field">
                  <span className="fin-label">Email address</span>
                  <input className="fin-input" type="email" value={form.email} onChange={set('email')} placeholder="you@example.com" autoComplete="email" />
                </label>
                <label className="fin-field">
                  <span className="fin-label">Phone (optional)</span>
                  <input className="fin-input" value={form.phone} onChange={set('phone')} placeholder="0801 234 5678" autoComplete="tel" />
                </label>

                <div className="fin-field">
                  <span className="fin-label">I am a&hellip;</span>
                  <div className="fin-seg-row">
                    <button type="button" className={'fin-seg' + (form.registrant_type === 'student' ? ' active' : '')} onClick={() => chooseType('student')}>Student</button>
                    <button type="button" className={'fin-seg' + (form.registrant_type === 'alumni' ? ' active' : '')} onClick={() => chooseType('alumni')}>Alumnus / Alumna</button>
                  </div>
                </div>

                {form.registrant_type === 'student' && (
                  <div className="fin-note">Students attend the finale <strong>in person</strong>.</div>
                )}

                {isAlumni && (
                  <>
                    <div className="fin-field">
                      <span className="fin-label">How will you attend?</span>
                      <div className="fin-seg-row">
                        <button type="button" className={'fin-seg' + (form.attendance_mode === 'in_person' ? ' active' : '')} onClick={() => setForm(f => ({ ...f, attendance_mode: 'in_person' }))}>In person</button>
                        <button type="button" className={'fin-seg' + (form.attendance_mode === 'online' ? ' active' : '')} onClick={() => setForm(f => ({ ...f, attendance_mode: 'online' }))}>Online</button>
                      </div>
                    </div>
                    <div className="fin-two">
                      <label className="fin-field">
                        <span className="fin-label">Graduation year</span>
                        <input className="fin-input" value={form.graduation_year} onChange={set('graduation_year')} placeholder="e.g. 2016" />
                      </label>
                      <label className="fin-field">
                        <span className="fin-label">Department</span>
                        <input className="fin-input" value={form.department} onChange={set('department')} placeholder="e.g. Electrical Eng." />
                      </label>
                    </div>
                  </>
                )}

                {error && <div className="fin-error">{error}</div>}

                <button type="submit" className="fin-submit" disabled={status === 'loading'}>
                  {status === 'loading' ? 'Submitting…' : 'Confirm my registration'}
                </button>
                <div className="fin-fine">A confirmation email will be sent to the address above.</div>
              </form>

              <div className="fin-footer">futurumawards.com</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function Success({ result, email }) {
  const online = result?.attendance_mode === 'online';
  return (
    <div>
      <div className="fin-tick">&#10003;</div>
      <h2 className="fin-success-title">{result?.updated ? 'Registration updated' : 'You are confirmed'}</h2>
      <p className="fin-success-text">
        {online ? 'You are set to join the Grand Finale online.' : 'We look forward to welcoming you to the Grand Finale in person.'}
      </p>
      <div className="fin-ref-box">
        <div className="fin-ref-label">Your reference</div>
        <div className="fin-ref-code">{result?.reference}</div>
      </div>
      <p className="fin-success-text">
        A confirmation email is on its way to <strong>{email}</strong>.
        {online ? ' The streaming link will follow closer to the date.' : ' Please bring this reference and a valid ID to the venue.'}
      </p>
      <div className="fin-footer">futurumawards.com</div>
    </div>
  );
}
